<template>
  <small-button v-on:click="goToTop()">{{ $nippets.top }}</small-button>
</template>

<script>
export default {
  methods: {
    goToTop () {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth'});
    }
  }
}
</script>

<style>

</style>
